import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service'; // Certifique-se de ajustar o caminho correto
import { FormsModule, NgModel } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'], // Corrigido para "styleUrls"
})
export class ProfileComponent implements OnInit {
  name: string | null = '';
  picture: string | null = '';
  email: string | null = '';
  phone: string | null = '';
  cep: string | null = '';
  address: string | null = '';
  district: string | null = '';
  city: string | null = '';
  UF: string | null = '';
  ID: string | null = '';
  constructor(private userService: UserService) {}

  ngOnInit() {
    this.name = localStorage.getItem('name');
    this.picture = localStorage.getItem('picture');
    this.email = localStorage.getItem('email');
    this.phone = localStorage.getItem('phone');
    this.cep = localStorage.getItem('CEP');
    this.address = localStorage.getItem('address');
    this.district = localStorage.getItem('district');
    this.city = localStorage.getItem('city');
    this.UF = localStorage.getItem('UF');
    this.ID = localStorage.getItem('id');
  }

  saveChanges() {
    const userData = {
      id: this.ID ? +this.ID : 0, 
      name: this.name || '',
      CEP: this.cep || '',
      address: this.address || '',
      district: this.district || '',
      UF: this.UF || '',
    };

    this.userService.editInfos(userData).subscribe({
      next: (response) => {
          Swal.fire({
                      text: 'Informações atualizadas, muito obrigado!',
                      icon: 'success',
                      toast: true,
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 4000,
                      timerProgressBar: true
                    });
                localStorage.setItem('name', userData.name);
      },
      error: (error) => {
        Swal.fire({
                    text: 'Algo deu errado',
                    icon: 'error',
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 4000,
                    timerProgressBar: true
        });
      },
    });
  }
}
